export const headers = [
  "pmxReleaseId",
  "pmxReleaseName",
  "dismissed",
  "id",
  "exceptionStatus",
  "exceptionType",
  "exception",
  "licensee",
  "dealId",
  "catalogId",
  "radarId",
  "catalogName",
  "territoryName",
  "mediaName",
  "format",
  "tprStartDate",
  "tprEndDate",
  "exceptionTimeStamp",
  "dismissBy",
];

export const renamedHeaders = [
  "TPR Release Id",
  "TPR Release Title",
  "Dismissed",
  "Exception ID",
  "Exception Status",
  "Exception Type",
  "Error Message",
  "Licensee",
  "Deal ID",
  "Catalog ID",
  "Enterprise Product ID",
  "Catalog Name",
  "Territory",
  "Media",
  "Format",
  "TPR Start Date",
  "TPR End Date",
  "Exception Timestamp",
  "Dismissed By",
];
